// eslint-disable-next-line import/no-extraneous-dependencies
import { Box, Skeleton } from '@mui/material';
import Typography from '@digital-hig/typography';
import React from 'react';

const UnorderedListSkeleton = () => (
  <Box component="ul">
    <Typography variant="headline-medium" mb={4}>
      <Skeleton animation="pulse" variant="text" />
    </Typography>
    {[...Array(4).keys()].map((e) => <Typography key={`unordered-shimmer-${e}`} component="li"><Skeleton animation="pulse" variant="text" width="30%" /></Typography>)}
  </Box>
);
export default UnorderedListSkeleton;
